/**
 * The Stage (unit convention §1).
 *
 * Per UX spec §6a this folder is context-free: no `useSocket`, no
 * `useNavigation`, no `useRoute`, no `useMediaQuery`, no `useContext` — see the
 * `no-restricted-imports` override for `stage/**` in .eslintrc.js.
 */
import React from 'react';

import {bump} from '../renderCount';
import {useStageModel} from './model';
import StageView from './View';

export default React.memo(function Stage() {
  bump('Stage');
  return <StageView {...useStageModel()} />;
});
